export default __webpack_public_path__ + "static/media/Twitter.9032dea8.svg";